import axios from "axios";

import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getDate = async(an8) => {

  const url = `${ baseUrl }/date/saleOrder/${an8}`;

  const token = await authHeader();

  return axios.get(url,
    { headers: token }
  ).then(
      (response) => {
        return response.data;
  })
};

const getCompany =  async(an8) => {

  const url = `${ baseUrl }/company/saleOrder/${an8}`;

  const token = await authHeader();

  return axios.get(url,
    { headers: token }
    ).then(
      (response) => {
        return response.data;
  })
};

const getAllSaleOrderByFilters = async(params, an8Logged) => {

  const data = {
    startDate: params.startDate ? params.startDate : "",
    endDate: params.endDate ? params.endDate : "",
    plant: params.company ? params.company : "",
    user: params.an8 ? params.an8 : "",
    an8Administrator: an8Logged,
    userAll: params.userAll ? params.userAll : "",
    invoiced:params.invoice === "all" ? "" : params.invoice

  };

  const token = await authHeader();

    let url = `${ baseUrl }/saleOrder/${params.an8}`;
    return axios
      .get(url, {
        params: data,
        headers: token 
        }
      )
      .then(response => {
        return response.data;
       }
       )
  };

const downloadSaleOrderDetailXlsx = async (dataOrder, an8) => {
  const url = `${ baseUrl }/saleOrder/excel/${an8}`;
  const token = await authHeader();

  return axios
    .post(url,dataOrder, {
      headers: token 
    },
    {
      responseType: 'blob'
    }
    )
    .then(response => {
      return response.data;
      }
      )
};
/**
   * Descarga todas las ordenes de venta de todos los an8
   * @param {*} data - Contenido de la solicitud
   * @author KenzoSashida
   * @version 1.0.0 - Agosto 2024
*/
const downloadAllSalesOrderAn8 = async (data,an8) =>{
  const url = `${ baseUrl }/saleOrder/excel-all/${an8}`;
  const token = await authHeader();
  return axios.post(url,data,{
    headers: token
  },{
    responseType:"blob"
  }).then((response)=>{
    return response.data;
  })
}
  export default {
    getDate,
    getCompany,
    getAllSaleOrderByFilters,
    downloadSaleOrderDetailXlsx,
    downloadAllSalesOrderAn8
  }